export default {"src":"/_next/static/media/new_lock.67c93a76.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};